import BaseMygocuApiService from './BaseMygocuApiService';

const USUARIO_API_VERSION = 'v1/';
const USUARIO_API_BASEPATH_URL = '/rooming/' + USUARIO_API_VERSION;

class RoomingApiService {
  async getRoomingList() {
    return await BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL);
  }

  async getRoomingByID(id) {
    return await BaseMygocuApiService.get(USUARIO_API_BASEPATH_URL.concat(`${id}`));
  }

  async saveRooming(id, data) {
    return await BaseMygocuApiService.patch(USUARIO_API_BASEPATH_URL.concat(`${id}`), data);
  }

  async confirmRooming(id) {
    return await BaseMygocuApiService.post(USUARIO_API_BASEPATH_URL.concat(`${id}/confirm`));
  }
}

export default new RoomingApiService();
